<div class="flex justify-center">
  <div class="page-container">
    <h1>{{ header1 }}</h1>

    <div class="mt-2">
      <ng-container *ngFor="let elem of info; let i = index">
        <app-list-element [color]="elem.color" [iconOrIndex]="(i+1).toString()" [text]="elem.text"></app-list-element>
      </ng-container>
    </div>

    <div class="flex justify-center mt-3">
      <button (click)="goToContactForm()" class="form-button" i18n mat-flat-button>Go to Contact Form</button>
    </div>
  </div>
</div>
